import React from 'react';
import { Redirect, Stack, usePathname } from 'expo-router';
import { Platform } from 'react-native';
import { CommunitiesHeader } from '@/components/layout/CommunitiesHeader';
import { useIsLargeScreen } from '@/hooks/useIsLargeScreen';
import { CommunitiesFooter } from '@/components/layout/CommunitiesFooter';
import { getCommunityFromDomain, isCommunityCode } from '@/constants/communities';

export const unstable_settings = {
  initialRouteName: '[community]/sign-in',
};

export default function CommunitiesLayout() {
  const isLargeScreen = useIsLargeScreen();
  const pathname = usePathname();
  const pathSegments = pathname.split('/').filter(Boolean);
  const selectedCommunity = pathSegments[1];
  const isCommunityDetailPage = pathSegments.length === 2;
  const domainCommunity = getCommunityFromDomain();

  // On web, auth/account routes must match the community implied by the hostname.
  // The public community detail page is the exception: it can preview any community.
  if (
    Platform.OS === 'web' &&
    !isCommunityDetailPage &&
    isCommunityCode(selectedCommunity) &&
    domainCommunity &&
    domainCommunity !== selectedCommunity
  ) {
    return <Redirect href="/communities" />;
  }

  return (
    <>
      <Stack
        screenOptions={{
          header: (props) => {
            const headerLeftOption: any = (props.options as any).headerLeft;
            const providedTitle: string | undefined = (props.options as any).title;
            const leftNode = typeof headerLeftOption === 'function'
              ? headerLeftOption({
                  canGoBack: !!props.back,
                  labelVisible: false,
                  tintColor: undefined,
                  pressColor: undefined,
                } as any)
              : headerLeftOption;

            return (
              <CommunitiesHeader
                title={providedTitle ?? (isLargeScreen ? "Grokio Communities" : "")}
                headerClassName="bg-neutral-800"
                rightIconMode={!isLargeScreen}
                rightNeutral
                hideBackOnRoot
                leftNode={leftNode}
              />
            );
          },
        }}
      />
      <CommunitiesFooter />
    </>
  );
}


